import { combineEpics } from "redux-observable";
import {
  fetchProductsByUser,
  fetchProductByName,
  fetchProductById,
  fetchProductPhaseByName,
  createProduct,
  updateProduct,
  updateProductVersions,
  updateProductPhases,
  deleteProduct,
} from "./productEpics";
import { deleteVersion, updateVersion } from "./versionEpics";
import {
  fetchPhases,
  createPhase,
  updatePhase,
  deleteVersionPhaseByPhase,
} from "./phaseEpics";
import {
  fetchProductSuitesByUser,
  createProductSuite,
  updateProductSuite,
  deleteProductSuite,
} from "./productSuiteEpics";
import {
  fetchProductGroupsByUser,
  createProductGroup,
  updateProductGroup,
  deleteProductGroup,
} from "./productGroupEpics";
import { updateProductLink } from "./productLinkEpics";
import {
  fetchUsers,
  fetchUserById,
  fetchCurrentUsers,
  createUser,
  updateUser,
  deleteUser,
} from "./userEpics";
import { fetchActivities, fetchActivityById } from "./activityEpics";

export default combineEpics(
  // product
  fetchProductsByUser,
  fetchProductByName,
  fetchProductById,
  fetchProductPhaseByName,
  createProduct,
  updateProduct,
  updateProductVersions,
  updateProductPhases,
  deleteProduct,

  // version
  deleteVersion,
  updateVersion,

  // phase
  fetchPhases,
  createPhase,
  updatePhase,
  deleteVersionPhaseByPhase,

  // productSuite
  fetchProductSuitesByUser,
  createProductSuite,
  updateProductSuite,
  deleteProductSuite,

  // productGroup
  fetchProductGroupsByUser,
  createProductGroup,
  updateProductGroup,
  deleteProductGroup,

  // productLink
  updateProductLink,

  // users
  fetchUsers,
  fetchUserById,
  fetchCurrentUsers,
  createUser,
  updateUser,
  deleteUser,

  // activities
  fetchActivities,
  fetchActivityById
);
